import { computed } from '@vue/composition-api';
import { useStore } from '@/core/store';

export default function useGetExperience (locationId) {
  const store = useStore();

  const experiences = computed(() => {
    return store.getters.locationExperiences(locationId);
  });

  return {
    experiences,
  };
}
